import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_flex _ai-c _gap-2 _ai-fs" }
const _hoisted_2 = { class: "_flex-col _gap-2 _grow-1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_avatar = _resolveComponent("skeleton-avatar")
  const _component_skeleton_paragraph = _resolveComponent("skeleton-paragraph")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_skeleton_avatar),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_skeleton_paragraph, { lines: $props.mediaLinesCount }, null, 8 /* PROPS */, ["lines"])
    ])
  ]))
}